import { render, staticRenderFns } from "./UpdateProfilePopup.vue?vue&type=template&id=0dc19262"
import script from "./UpdateProfilePopup.vue?vue&type=script&lang=js"
export * from "./UpdateProfilePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports